import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  "@keyframes fadeInUp": {
    from: { opacity: 0, transform: "translateY(8px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    animation: "$fadeInUp 150ms ease-out 360ms both",
  },
  button: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#2563eb",
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: "9px",
    padding: "7px 15px",
    cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
    transition: "all 150ms",
    lineHeight: 1.4,
    "&:hover": {
      background: "#EFF4FF",
      color: "#1E3A5F",
      borderColor: "#BFDBFE",
    },
  },
}));

var FollowUpButtons = React.memo(function FollowUpButtons({ followUps, onSelect }) {
  var classes = useStyles();

  if (!followUps || !followUps.length) return null;

  return (
    <div className={classes.container}>
      {followUps.map(function (fu, i) {
        return (
          <button
            key={i}
            className={classes.button}
            onClick={function () { onSelect(fu); }}
          >
            {fu}
          </button>
        );
      })}
    </div>
  );
});

export default FollowUpButtons;
